import { Box, Paper, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
import { palette, theme as colorTheme } from "../../../Convoze.theme";


const primary = colorTheme("palette", "primary").value;
const primaryBg = colorTheme("palette", "primaryBg").value;
const positive = colorTheme("palette", "positive").value;
const negative = colorTheme("palette", "negative").value;
const neutral = colorTheme("palette", "neutral").value;



function Graph({ graphData }) {

  const token = localStorage.getItem("token");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: (params) => {
        const p = Array.isArray(params) ? params[0] : params;
        const name = p?.name ?? "";
        const val = p?.value ?? 0;
        return `<span style="color:#666;font-weight:bold">${name}</span><br/>Score: <span style="color:#9C9FFA;font-weight:bold">${val}</span>`;
      },
      confine: true,
      renderMode: "html",
    },
    xAxis: {
      type: "category",
      data: graphData?.levelWithDay || ["","","","","","",""],
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        data: graphData?.value || [0, 0, 0, 0, 0, 0, 0],
        type: "bar",
        showBackground: true,
        backgroundStyle: {
          color: "rgba(180, 180, 180, 0.2)",
        },
        itemStyle: {
          color: primary
        },
      },
    ],
  };
  return (
    <>
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          p: 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", md: "row" },
            gap: 1,
          }}
        >
          <Typography
            variant="h6"
            component="h2"
            fontWeight="600"
            color="text.primary"
          >
            Performance Trend
          </Typography>
        </Box>
        <ReactECharts
          option={option}
          style={{ height: "100%", width: "100%" }}
        />
      </Paper>
    </>
  );
}

export default Graph;
